import React from "react";

const SepFooter = ({ data }) => {
    return (
        <div className="relative h-[816px] xs:h-auto">
            <img
                src={data.mainImage}
                alt="Background"
                className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>

            <div className="relative text-white ml-8 my-8 py-[20%] px-6 xs:m-2 xs:p-6 xs:ml-0 xs:mr-0">
                <h2 className="text-6xl xs:text-3xl xs:text-center lg:text-5xl 2xl:text-5xl">
                    {data.title}
                </h2>
                <h3 className="pt-10 pb-4 px-2 text-2xl font-normal xs:text-lg xs:pt-2 xs:pb-2 xs:text-center lg:text-2xl">
                    {data.textRegular}
                </h3>
                <a
                    href={`${data.link}?source=${encodeURIComponent(data.source)}`}
                    className="xs:w-full xs:flex xs:justify-center"
                >
                    <button className="bg-[#EC0000] text-white px-6 py-3 rounded-2xl mt-4 font-bold">
                        {data.actionPrimary}
                    </button>
                </a>
            </div>
        </div>
    );
};

export default SepFooter;
